// extracted by mini-css-extract-plugin
export default {"checkbox":"Gf95d06","label":"G0789f5"};